const normalizeCategoryName = (categoryName?: string) => {
  let result = categoryName?.split('-')?.join(' ');

  // remove 's' if category name is plural
  if (result?.endsWith('s')) {
    result = result?.slice(0, -1);
  }

  return result;
};

export default normalizeCategoryName;
